import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from 'app/routes';
import { ContextProvider as ProgramContext } from 'components/Members/Programs/Views/Show/Context';
import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import ChangeTopic from 'components/Members/Programs/Views/Show/ChangeTopic/Index';
import WebView from 'components/WebView/Index';

import ErrorBoundary from 'components/new_ui/Errors/ErrorBoundary';
import Main from './Main';

import { ContextProvider } from './Context';

import WelcomeStep from './Steps/Welcome';
import WelcomeRTWStep from './Steps/WelcomeRTW';
import WelcomeCpaStep from './Steps/WelcomeCpa';
import ContinueStep from './Steps/Continue';
import ContinueCpaStep from './Steps/ContinueCpa';

import StartTalentAssessmentStep from './Steps/TalentAssessment/StartTalentAssessment';
import TalentAssessmentStep from './Steps/TalentAssessment/TalentAssessment';
import PrepareAssessmentReportStep from './Steps/TalentAssessment/PrepareReport';
import AssessmentReportStep from './Steps/TalentAssessment/TalentAssessmentReport';
import TalentAssessmentDownload from './Steps/TalentAssessment/TalentAssessmentDownload';
import FinishCpaStep from './Steps/TalentAssessment/Finish';

import PrepareBuildProgramStep from './Steps/BuildProgram/PrepareBuildProgram';
import OrderProgramTopicStep from './Steps/BuildProgram/OrderTopic';

import CoachMatchStep from './Steps/LearningStyleAssessment/CoachMatch';
import LearningStyleStep from './Steps/LearningStyleAssessment/LearningStyle';

import PreferencesStep from './Steps/SelectCoach/Preferences';
import FindingCoach from './Steps/SelectCoach/FindingCoach';
import ChooseCoach from './Steps/SelectCoach/ChooseCoach';

import FinalizeStep from './Steps/StartProgram/Finalize';
import SummaryProgramStep from './Steps/StartProgram/SummaryProgram';

export default function Index({ programId }) {
  const router = createBrowserRouter([
    {
      path: routes.members.onboarding.index,
      element: <Main programId={programId} />,
      errorElement: <ErrorBoundary />,
      children: [{
        path: routes.members.onboarding.welcome,
        element: <WelcomeStep />,
      }, {
        path: routes.members.onboarding.continue,
        element: <ContinueStep />,
      },
      {
        path: routes.members.onboarding.welcomeCpa,
        element: <WelcomeCpaStep />,
      },
      {
        path: routes.members.onboarding.continueCpa,
        element: <ContinueCpaStep />,
      },
      {
        path: routes.members.onboarding.welcomeRTW,
        element: <WelcomeRTWStep />,
      },
      {
        path: routes.members.onboarding.start_talent_assessment,
        element: <StartTalentAssessmentStep />,
      },
      {
        path: routes.members.onboarding.talent_assessment,
        element: <TalentAssessmentStep />,
      },
      {
        path: routes.members.onboarding.prepare_assessment_report,
        element: <PrepareAssessmentReportStep />,
      },
      {
        path: routes.members.onboarding.talent_assessment_report,
        element: <AssessmentReportStep />,
      },
      {
        path: routes.members.onboarding.talentAssessmentDownload,
        element: <TalentAssessmentDownload />,
      },
      {
        path: routes.members.onboarding.prepareBuildProgram,
        element: <PrepareBuildProgramStep />,
      },
      {
        path: routes.members.onboarding.orderTopic(),
        element: <ProgramContext><OrderProgramTopicStep /></ProgramContext>,
        children: [{
          path: routes.members.programs.new.setTopic(),
          element: <ChangeTopic />,
        }],
      },
      {
        path: routes.members.onboarding.coachMatch,
        element: <CoachMatchStep />,
      },
      {
        path: routes.members.onboarding.learningStyle,
        element: <LearningStyleStep />,
      },
      {
        path: routes.members.onboarding.preferences,
        element: <PreferencesStep />,
      },
      {
        path: routes.members.onboarding.findingCoach,
        element: <FindingCoach />,
      },
      {
        path: routes.members.onboarding.chooseCoach(),
        element: <ProgramContext><ChooseCoach /></ProgramContext>,
      },
      {
        path: routes.members.onboarding.finalize,
        element: <FinalizeStep />,
      },
      {
        path: routes.members.onboarding.summary(),
        element: <ProgramContext><SummaryProgramStep /></ProgramContext>,
      },
      {
        path: routes.members.onboarding.finish,
        element: <FinishCpaStep />,
      },
      {
        path: routes.members.onboarding.webview,
        element: <WebView />,
      },
      ],
    },
  ]);

  return (
    <StrictMode>
      <UsersContextProvider>
        <ContextProvider>
          <RouterProvider router={router} />
        </ContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  programId: PropTypes.number,
};

Index.defaultProps = {
  programId: null,
};
